import { CommonModule } from '@angular/common'
import { NgModule, ErrorHandler, inject } from '@angular/core'
import { MdbRangeModule } from 'mdb-angular-ui-kit/range'
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'

function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json')
}

import { environment } from '../../environments/environment'
import {
  ROUTE_ANIMATIONS_ELEMENTS,
  routeAnimations,
} from './animations/route.animations'
import { AnimationsService } from './animations/animations.service'
import { AppErrorHandler } from './error-handler/app-error-handler.service'
import { HttpErrorInterceptor } from './http-interceptors/http-error.interceptor'
import { NotificationService } from './notifications/notification.service'
import { LocalStorageService } from './local-storage/local-storage.service'

export {
  routeAnimations,
  ROUTE_ANIMATIONS_ELEMENTS,
  AnimationsService,
  NotificationService,
  LocalStorageService,
}

@NgModule({
  declarations: [],
  exports: [TranslateModule],
  imports: [
    // angular
    CommonModule,
    // 3rd party
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MdbRangeModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true })

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule')
    }
  }
}
